export const STOP_PAYMENT_ACTIVITY_CONTAINER_TAG_NAME = 'stop-payment-activity-container';
